<script setup lang="ts">
import supportedBrowsers from "@/utils/supportedBrowsers";

const { t } = useI18n();

const isLegacyBrowser = computed(() => {
  return !supportedBrowsers.test(navigator.userAgent);
});
</script>

<template>
  <div v-if="isLegacyBrowser" class="alert alert-warning mb-4">
    {{ t("hints.legacyBrowserBanner") }}
  </div>
</template>
